import { render, staticRenderFns } from "./PublicizeDetail.vue?vue&type=template&id=57d83f04&scoped=true&"
import script from "./PublicizeDetail.vue?vue&type=script&lang=js&"
export * from "./PublicizeDetail.vue?vue&type=script&lang=js&"
import style0 from "./PublicizeDetail.vue?vue&type=style&index=0&id=57d83f04&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d83f04",
  null
  
)

export default component.exports